<template>
  <div class="t-content">
    <div class="t-content-top">
      <div class="t-radius">
        <div class="header-info">
          <div class="name">{{ $t('dataAnalysis.synthesis.teachingDataPage.classStatistics') }}</div>
          <div class="info">
            <span style="padding-right: 30px;">
              {{ $t('dataAnalysis.synthesis.teachingDataPage.classCount') }}：
              <span class="num"> {{ statisticalMap.classCount }} </span>{{ $t('dataAnalysis.synthesis.teachingDataPage.times') }}</span
            >
            <span>
              {{ $t('dataAnalysis.synthesis.teachingDataPage.teacherCount') }}：
              <span class="num"> {{ statisticalMap.teacherCount }} </span>{{ $t('dataAnalysis.synthesis.teachingDataPage.people') }}</span
            >
          </div>
        </div>
        <div id="chat-1" class="chart"></div>
      </div>
      <div class="t-radius">
        <div class="header-info">
          <div class="name">{{ $t('dataAnalysis.synthesis.teachingDataPage.course') }}</div>
          <div class="info">
            <a-select
              style="width: 140px; margin-right: 30px;"
              :placeholder="$t('dataAnalysis.synthesis.teachingDataPage.selectYear')"
              v-model="statisticalMap.courseYear"
              @change="initChart2"
              :allowClear="true"
              :getPopupContainer="getPopupContainer"
            >
              <a-select-option v-for="year in yearOptions" :key="year" :value="year"> {{ year }}{{ $t('dataAnalysis.synthesis.teachingDataPage.year') }} </a-select-option>
            </a-select>
            <a-select
              style="width: 140px"
              :placeholder="$t('dataAnalysis.synthesis.teachingDataPage.selectClass')"
              v-model="statisticalMap.courseClassId"
              @change="initChart2"
              :allowClear="true"
              :getPopupContainer="getPopupContainer"
            >
              <a-select-option :value="item.value" v-for="(item, index) in classList" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div id="chat-2" class="chart"></div>
      </div>
      <div class="t-radius">
        <div class="header-info">
          <div class="rose-chart-info">
            <span style="padding-right: 30px;"
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.courseCount') }}：<span class="num">{{ statisticalMap.courseCount }}</span
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.times') }}</span
            >
            <span style="padding-right: 30px;"
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.totalCourseHours') }}：<span class="num">{{ statisticalMap.totalCourseHours }}</span
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.hour') }}</span
            >
            <span>{{ $t('dataAnalysis.synthesis.teachingDataPage.sessionCount') }}：<span class="num">10</span>{{ $t('dataAnalysis.synthesis.teachingDataPage.times') }}</span>
          </div>
        </div>
        <div class="rose-chart">
          <div id="chat-3" class="chart"></div>
          <div class="legend">
            <div v-for="(item, inx) in statisticalMap.resTypes" :key="inx">
              <div :style="{ backgroundColor: item.color }"></div>
              <div>{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="t-content-center">
      <div class="t-radius">
        <div class="header-info">
          <div class="name">{{ $t('dataAnalysis.synthesis.teachingDataPage.experimentData') }}</div>
          <div class="info">
            <a-select
              style="width: 140px; margin-right: 30px;"
              :placeholder="$t('dataAnalysis.synthesis.teachingDataPage.selectYear')"
              v-model="statisticalMap.labYear"
              @change="initChart4"
              :allowClear="true"
              :getPopupContainer="getPopupContainer"
            >
              <a-select-option v-for="year in yearOptions" :key="year" :value="year"> {{ year }}{{ $t('dataAnalysis.synthesis.teachingDataPage.year') }} </a-select-option>
            </a-select>
            <span style="padding-right: 30px;"
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.experimentCount') }}：<span class="num">{{ statisticalMap.labCount }}</span
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.times') }}</span
            >
            <span
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.studentCount') }}：<span class="num">{{ statisticalMap.studentCount }}</span
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.people') }}</span
            >
          </div>
        </div>
        <div id="chat-4" class="chart"></div>
      </div>
      <div class="t-radius">
        <div class="header-info">
          <div class="name">{{ $t('dataAnalysis.synthesis.teachingDataPage.experimentScoreData') }}</div>
          <div class="info">
            <!-- 添加起止时间选择器 -->
            <a-range-picker
              style="width: 240px; margin-right: 30px;"
              :placeholder="$t('dataAnalysis.synthesis.teachingDataPage.selectDateRange')"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              v-model="statisticalMap.labTime"
              :allowClear="true"
              @change="initChart5"
              :getCalendarContainer="getPopupContainer"
            ></a-range-picker>
            <a-select
              style="width: 140px; margin-right: 30px;"
              :placeholder="$t('dataAnalysis.synthesis.teachingDataPage.selectExperiment')"
              v-model="statisticalMap.labId"
              @change="initChart5"
              :allowClear="true"
              :getPopupContainer="getPopupContainer"
            >
              <a-select-option :value="item.value" v-for="(item, index) in experimentList" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.publishCount') }}：<span class="num">{{ statisticalMap.publishedLabsCount }}</span
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.times') }}</span
            >
          </div>
        </div>
        <div class="line-chart">
          <div class="left">
            <div id="chat-5" class="chart-line"></div>
            <div class="class">
              <div>
                <div style="width: 10px; height: 10px; background-color: #FD8C6C; border-radius: 50%;"></div>
                <div>{{ $t('dataAnalysis.synthesis.teachingDataPage.submissionRate') }}</div>
              </div>
              <div>
                <div style="width: 10px; height: 10px; background-color: #3E9FEC; border-radius: 50%;"></div>
                <div>{{ $t('dataAnalysis.synthesis.teachingDataPage.passRate') }}</div>
              </div>
            </div>
          </div>
          <!-- <div class="right">
            <div class="lable">
              <div>{{ $t('dataAnalysis.synthesis.teachingDataPage.highestScore') }}</div>
              <div>{{ $t('dataAnalysis.synthesis.teachingDataPage.lowestScore') }}</div>
              <div>{{ $t('dataAnalysis.synthesis.teachingDataPage.medianScore') }}</div>
              <div>{{ $t('dataAnalysis.synthesis.teachingDataPage.averageScore') }}</div>
            </div>
            <div class="value">
              <div>98</div>
              <div>56</div>
              <div>323</div>
              <div>43</div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="t-content-bottom">
      <div class="t-radius">
        <div class="header-info">
          <div class="name">{{ $t('dataAnalysis.synthesis.teachingDataPage.questionData') }}</div>
          <div class="info">
            <span style="padding-right: 30px;"
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.questionCount') }}：<span class="num">{{ statisticalMap.questionCount }}</span
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.questionUnit') }}</span
            >
            <span
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.chapterCount') }}：<span class="num">{{ statisticalMap.chapterCount }}</span
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.chapterUnit') }}</span
            >
          </div>
        </div>
        <div class="chart-pie">
          <div id="chat-6-1"></div>
          <div id="chat-6-2"></div>
          <div id="chat-6-3"></div>
        </div>
      </div>
      <div class="t-radius">
        <div class="header-info">
          <div class="name">{{ $t('dataAnalysis.synthesis.teachingDataPage.theoreticalAssessment') }}</div>
          <div class="info">
            <a-range-picker
              style="width: 240px; margin-right: 30px;"
              :placeholder="$t('dataAnalysis.synthesis.teachingDataPage.selectDateRange')"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              v-model="statisticalMap.testTime"
              :allowClear="true"
              @change="initChart7"
              :getCalendarContainer="getPopupContainer"
            ></a-range-picker>
            <a-select
              style="width: 160px; margin-right: 30px;"
              :placeholder="$t('dataAnalysis.synthesis.teachingDataPage.selectTheoretical')"
              :allowClear="true"
              v-model="statisticalMap.testId"
              @change="initChart7"
              :getPopupContainer="getPopupContainer"
            >
              <a-select-option :value="item.value" v-for="(item, index) in testList" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.publishCount') }}：<span class="num">{{ statisticalMap.publishedTheoriesCount }}</span
              >{{ $t('dataAnalysis.synthesis.teachingDataPage.times') }}</span
            >
          </div>
        </div>
        <div class="line-chart">
          <div class="left">
            <div id="chat-7" class="chart-line"></div>
            <div class="class">
              <div>
                <div style="width: 10px; height: 10px; background-color: #FD8C6C; border-radius: 50%;"></div>
                <div>{{ $t('dataAnalysis.synthesis.teachingDataPage.submissionRate') }}</div>
              </div>
              <div>
                <div style="width: 10px; height: 10px; background-color: #43C391; border-radius: 50%;"></div>
                <div>{{ $t('dataAnalysis.synthesis.teachingDataPage.passRate') }}</div>
              </div>
            </div>
          </div>
          <!-- <div class="right">
            <div class="lable">
              <div>最高分</div>
              <div>最低分</div>
              <div>中位分</div>
              <div>平均分</div>
            </div>
            <div class="value">
              <div>98</div>
              <div>56</div>
              <div>323</div>
              <div>43</div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {
  getExamineList,
  getExperimentExamineList,
  getClassStatisticsData,
  getExperimentScoreData,
  getExperimentBasicsData,
  getLessonBasicsData,
  getLessonStatisticsData,
  getQuestionStatisticsData,
  getTheoryStatisticsData
} from '@/api/chart'
import { labList } from '@/api/admin'
import { classList } from '@/api/lesson'

export default {
  name: 'TeachingData',
  props: {
    contentRef: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      testList: [],
      experimentList: [],
      classList: [],
      yearOptions: Array.from({ length: 10 }, (_, i) => 2024 + i + ''), // 生成2024-2033年的数组
      statisticalMap: {
        classCount: 0,
        teacherCount: 0,
        courseCount: 0,
        totalCourseHours: 0,
        sessionCount: 0,
        labCount: 0,
        studentCount: 0,
        publishedLabsCount: 0,
        publishedTheoriesCount: 0,
        questionCount: 0,
        chapterCount: 0,
        resTypes: [],
        courseYear: undefined,
        courseClassId: undefined,
        labYear: undefined,
        labTime: [],
        labId: undefined,
        testId: undefined,
        testTime: []
      }
    }
  },
  mounted() {
    this.getExamineListData()
    setTimeout(() => {
      this.initChart()
      console.log('statisticalMap ----->', this.statisticalMap)
    }, 500)
  },
  methods: {
    getPopupContainer(triggerNode) {
      return triggerNode.parentNode
    },
    initChart() {
      this.initChart1()
      this.initChart2()
      this.initChart3()
      this.initChart4()
      this.initChart5()
      this.initChart6()
      this.initChart7()
    },
    initChart1() {
      getClassStatisticsData().then(res => {
        if (res.code === 200) {
          const xAxisData = res.data.chart.map(item => item.name || this.$t('dataAnalysis.synthesis.teachingDataPage.testClass'))
          const seriesData = res.data.chart.map(item => item.data[0].value)
          const virtualXAxisData = [this.$t('dataAnalysis.synthesis.teachingDataPage.class1'), this.$t('dataAnalysis.synthesis.teachingDataPage.class2'), this.$t('dataAnalysis.synthesis.teachingDataPage.class3'), this.$t('dataAnalysis.synthesis.teachingDataPage.class4'), this.$t('dataAnalysis.synthesis.teachingDataPage.class5')]
          const virtualSeriesData = [34, 34, 54, 32, 24]

          this.statisticalMap.teacherCount = xAxisData.length ? res.data.teacherCount : 10
          this.statisticalMap.classCount = xAxisData.length ? res.data.classCount : 5
          this.initSingleChart(
            'chat-1',
            this.getBarChartOption(
              {
                seriesName: this.$t('dataAnalysis.synthesis.teachingDataPage.classStatistics'),
                barColor: '#379EFE',
                xAxisName: this.$t('dataAnalysis.synthesis.teachingDataPage.class'),
                yAxisName: this.$t('dataAnalysis.synthesis.teachingDataPage.studentCount'),
                xAxisData: xAxisData.length ? xAxisData : virtualXAxisData,
                seriesData: seriesData.length ? seriesData : virtualSeriesData,
                unit: this.$t('dataAnalysis.synthesis.teachingDataPage.people')
              },
              'jxb'
            )
          )
        }
      })
    },
    initChart2() {
      const params = {
        year: this.statisticalMap.courseYear,
        classId: this.statisticalMap.courseClassId
      }
      getLessonBasicsData(params).then(res => {
        if (res.code === 200) {
          const xAxisData = res.data.chart.map(item => item.name || this.$t('dataAnalysis.synthesis.teachingDataPage.testCourse'))
          const seriesData = res.data.chart.map(item => item.data[0].value)
          const averageTimeList = res.data.chart.map(item => item.data[1].value)
          const virtualXAxisData = [
            this.$t('dataAnalysis.synthesis.teachingDataPage.robotRepair'),
            this.$t('dataAnalysis.synthesis.teachingDataPage.robotMaintenance'),
            this.$t('dataAnalysis.synthesis.teachingDataPage.robotDisassembly'),
            this.$t('dataAnalysis.synthesis.teachingDataPage.robotCognition'),
            this.$t('dataAnalysis.synthesis.teachingDataPage.robotOperation')
          ]
          const virtualSeriesData = [5, 6, 17, 14, 15]

          this.initSingleChart(
            'chat-2',
            this.getBarChartOption({
              seriesName: this.$t('dataAnalysis.synthesis.teachingDataPage.course'),
              barColor: '#FFA311',
              xAxisName: this.$t('dataAnalysis.synthesis.teachingDataPage.course'),
              yAxisName: this.$t('dataAnalysis.synthesis.teachingDataPage.times'),
              xAxisData: xAxisData.length ? xAxisData : virtualXAxisData,
              seriesData: seriesData.length ? seriesData : virtualSeriesData,
              unit: this.$t('dataAnalysis.synthesis.teachingDataPage.times'),
              averageTimeList
            })
          )
        }
      })
    },
    initChart3() {
      getLessonStatisticsData().then(res => {
        if (res.code === 200) {
          const virtualSeriesData = [
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.textType'),
              value: 3
            },
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.videoType'),
              value: 2
            },
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.imageType'),
              value: 4
            },
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.model3D'),
              value: 1
            },
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.software3D'),
              value: 1
            },
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.researchResource'),
              value: 1
            }
          ]
          const seriesData = res.data.chart.length ? res.data.chart : virtualSeriesData
          const colorGather = ['#48B4FF', '#6F5EE4', '#F75881', '#FFBA28', '#FED54B', '#FD8C6C', '#00946F']
          this.statisticalMap.courseCount = res.data.lessonCount
          this.statisticalMap.sessionCount = res.data.lessonCountTimes
          this.statisticalMap.totalCourseHours = Math.ceil(res.data.lessonDuration / 3600) // 秒转小时，进一法
          this.statisticalMap.resTypes = seriesData.map((item, inx) => ({
            name: item.name,
            color: colorGather[inx]
          }))

          this.initSingleChart(
            'chat-3',
            this.getRoseChartOption({
              seriesName: this.$t('dataAnalysis.synthesis.teachingDataPage.courseStatistics'),
              barColor: '#FFA311',
              seriesData,
              colors: colorGather
            })
          )
        }
      })
    },
    initChart4() {
      const params = {
        year: this.statisticalMap.labYear
      }
      getExperimentBasicsData(params).then(res => {
        if (res.code === 200) {
          const xAxisData = res.data.chart.map(item => item.name)
          const seriesData = res.data.chart.map(item => item.data[0].value)
          this.statisticalMap.labCount = res.data.experimentCount
          this.statisticalMap.studentCount = res.data.studentCount
          const virtualXAxisData = [
            this.$t('dataAnalysis.synthesis.teachingDataPage.robotRepair'),
            this.$t('dataAnalysis.synthesis.teachingDataPage.robotMaintenance'),
            this.$t('dataAnalysis.synthesis.teachingDataPage.robotDisassembly'),
            this.$t('dataAnalysis.synthesis.teachingDataPage.robotCognition'),
            this.$t('dataAnalysis.synthesis.teachingDataPage.robotOperation')
          ]
          const virtualSeriesData = [5, 6, 17, 14, 15]

          this.initSingleChart(
            'chat-4',
            this.getBarChartOption(
              {
                seriesName: this.$t('dataAnalysis.synthesis.teachingDataPage.experimentData'),
                barColor: '#43C391',
                xAxisName: this.$t('dataAnalysis.synthesis.teachingDataPage.name'),
                yAxisName: this.$t('dataAnalysis.synthesis.teachingDataPage.times'),
                xAxisData: xAxisData.length ? xAxisData : virtualXAxisData,
                seriesData: seriesData.length ? seriesData : virtualSeriesData,
                unit: this.$t('dataAnalysis.synthesis.teachingDataPage.times')
              },
              'lab'
            )
          )
        }
      })
    },
    initChart5() {
      const params = {
        startTime: this.statisticalMap.labTime[0],
        endTime: this.statisticalMap.labTime[1],
        experimentId: this.statisticalMap.labId
      }
      getExperimentScoreData(params).then(res => {
        if (res.code === 200) {
          const seriesData = [
            res.data.chart.map(item => item.data[0].value) || [], // 提交率
            res.data.chart.map(item => item.data[1].value) || [] // 提交率
          ]
          const xAxisData = res.data.chart.map(item => item.name || this.$t('dataAnalysis.synthesis.teachingDataPage.testCourse'))
          const virtualXAxisData = [this.$t('dataAnalysis.synthesis.teachingDataPage.experiment1'), this.$t('dataAnalysis.synthesis.teachingDataPage.experiment2'), this.$t('dataAnalysis.synthesis.teachingDataPage.experiment3'), this.$t('dataAnalysis.synthesis.teachingDataPage.experiment4'), this.$t('dataAnalysis.synthesis.teachingDataPage.experiment5')]
          const virtualSeriesData = [
            [34, 34, 54, 32, 24],
            [10, 10, 20, 15, 15]
          ]
          const statisticalInfo = res.data.chart
          this.statisticalMap.publishedLabsCount = res.data.publishCount

          this.initSingleChart(
            'chat-5',
            this.getLineChartOption(
              {
                seriesName: [this.$t('dataAnalysis.synthesis.teachingDataPage.submissionRate'), this.$t('dataAnalysis.synthesis.teachingDataPage.passRate')],
                lineColors: ['#FD8C6C', '#3E9FEC'], // 两种颜色
                xAxisName: this.$t('dataAnalysis.synthesis.teachingDataPage.name'),
                yAxisName: '',
                xAxisData: xAxisData.length ? xAxisData : virtualXAxisData,
                seriesData: seriesData[0].length ? seriesData : virtualSeriesData,
                unit: '%'
              },
              statisticalInfo
            )
          )
        }
      })
    },
    initChart6() {
      getQuestionStatisticsData().then(res => {
        if (res.code === 200) {
          this.statisticalMap.questionCount = res.data.questionCount || 13
          this.statisticalMap.chapterCount = res.data.chapterCount || 2
          const virtualSeriesData = [
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.multipleChoice'),
              value: 3
            },
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.fillBlank'),
              value: 2
            },
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.trueFalse'),
              value: 4
            },
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.singleChoice'),
              value: 3
            },
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.shortAnswer'),
              value: 1
            }
          ]
          const virtualSeriesData1 = [
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.robotApplication'),
              value: 3
            },
            {
              name: this.$t('dataAnalysis.synthesis.teachingDataPage.robotRepair'),
              value: 2
            }
          ]
          this.initSingleChart(
            'chat-6-1',
            this.getPieChartOption({
              seriesName: this.$t('dataAnalysis.synthesis.teachingDataPage.questionTypeDistribution'),
              seriesData: res.data.questionTypeChart.length ? res.data.questionTypeChart : virtualSeriesData,
              radius: ['25%', '60%'],
              colors: ['#FFA000', '#6287FD', '#43C391', '#FDE076', '#48B4FF']
            })
          )
          this.initSingleChart(
            'chat-6-3',
            this.getPieChartOption({
              seriesName: this.$t('dataAnalysis.synthesis.teachingDataPage.chapterQuestionDistribution'),
              seriesData: res.data.chapterQuestionChart.length ? res.data.chapterQuestionChart : virtualSeriesData1,
              radius: ['25%', '60%'],
              colors: ['#FF8B8A', '#FED54B', '#FD9A4A', '#FDE076', '#48B4FF']
            })
          )
        }
      })
      this.initSingleChart(
        'chat-6-2',
        this.getPieChartOption({
          seriesName: this.$t('dataAnalysis.synthesis.teachingDataPage.difficultyDistribution'),
          seriesData: [
            { value: 5, name: this.$t('dataAnalysis.synthesis.teachingDataPage.easy') },
            { value: 10, name: this.$t('dataAnalysis.synthesis.teachingDataPage.normal') },
            { value: 4, name: this.$t('dataAnalysis.synthesis.teachingDataPage.hard') }
          ],
          radius: ['25%', '60%'],
          colors: ['#43C391', '#6287FD', '#F75881', '#FDE076', '#48B4FF']
        })
      )
    },
    initChart7() {
      const params = {
        startTime: this.statisticalMap.testTime[0],
        endTime: this.statisticalMap.testTime[1],
        testId: this.statisticalMap.testId
      }
      getTheoryStatisticsData(params).then(res => {
        if (res.code === 200) {
          const seriesData = [
            res.data.chart.map(item => item.data[0].value), // 提交率
            res.data.chart.map(item => item.data[1].value) // 提交率
          ]
          const xAxisData = res.data.chart.map(item => item.name)
          const virtualXAxisData = [
            this.$t('dataAnalysis.synthesis.teachingDataPage.theoryTest1'),
            this.$t('dataAnalysis.synthesis.teachingDataPage.theoryTest2'),
            this.$t('dataAnalysis.synthesis.teachingDataPage.theoryTest3'),
            this.$t('dataAnalysis.synthesis.teachingDataPage.theoryTest4'),
            this.$t('dataAnalysis.synthesis.teachingDataPage.theoryTest5')
          ]
          const virtualSeriesData = [
            [34, 34, 54, 32, 24],
            [10, 10, 20, 15, 15]
          ]
          const statisticalInfo = res.data.chart
          this.statisticalMap.publishedTheoriesCount = res.data.theoryExamineCount || 0

          this.initSingleChart(
            'chat-7',
            this.getLineChartOption(
              {
                seriesName: [
                  this.$t('dataAnalysis.synthesis.teachingDataPage.submissionRate'),
                  this.$t('dataAnalysis.synthesis.teachingDataPage.passRate')
                ],
                lineColors: ['#FD8C6C', '#43C391'], // 两种颜色
                xAxisName: this.$t('dataAnalysis.synthesis.teachingDataPage.name'),
                yAxisName: '',
                xAxisData: xAxisData.length ? xAxisData : virtualXAxisData,
                seriesData: seriesData[0].length ? seriesData : virtualSeriesData,
                unit: '%'
              },
              statisticalInfo
            )
          )
        }
      })
    },
    // 通用图表初始化方法
    initSingleChart(chartId, option) {
      const chartDom = document.getElementById(chartId)
      if (!chartDom) return
      const myChart = echarts.init(chartDom)
      myChart.setOption(option)
      this.initChartResize(myChart)
    },
    // 获取柱状图配置
    getBarChartOption(config = {}, type = 'class') {
      const {
        barColor,
        xAxisName,
        yAxisName,
        xAxisData,
        seriesData,
        unit,
        seriesName = this.$t('dataAnalysis.synthesis.teachingDataPage.data'),
        averageTimeList
      } = config
      return {
        grid: {
          top: 30,
          bottom: 10,
          left: 15,
          right: 30,
          containLabel: true,
          backgroundColor: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 1,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(55, 158, 254, 0.1)'
              },
              {
                offset: 1,
                color: 'rgba(55, 158, 254, 0.3)'
              }
            ]
          }
        },
        tooltip: {
          show: true,
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: (params) => {
            if (type === 'class') {
              return `
                ${params.name} <br/>
                ${this.$t('dataAnalysis.synthesis.teachingDataPage.visitCount')} : ${params.value}${unit} <br/>
                ${this.$t('dataAnalysis.synthesis.teachingDataPage.averageVisitCount')}: ${averageTimeList[params.dataIndex]}${unit} <br/>
              `
            } else {
              return `
                ${params.seriesName} <br/>
                ${this.$t('dataAnalysis.synthesis.teachingDataPage.visitCount')} : ${params.value}${unit} <br/>
              `
            }
          }
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          name: xAxisName,
          nameTextStyle: {
            color: '#868686',
            padding: [0, 0, -30, -20],
            fontSize: 11
          },
          axisLine: {
            lineStyle: {
              color: '#E5E5E5'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            // x轴文字的配置
            show: true,
            textStyle: {
              color: '#262626',
              fontSize: 12
            },
            // 核心代码 默认展示4个字超出显示...
            formatter: function(value) {
              // x轴的文字改为竖版显示
              var str = value.split('')
              return str.slice(0, 3).join('') + (str.length > 3 ? '...' : '')
            }
          }
        },
        yAxis: {
          type: 'value',
          name: yAxisName,
          nameTextStyle: {
            color: '#868686',
            padding: [0, 0, 0, -20],
            fontSize: 11
          },
          axisLine: {
            lineStyle: {
              color: '#E5E5E5'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: '#E5E5E5'
            }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: 'rgba(245,250,254, 0.8)'
            }
          },
          axisLabel: {
            color: '#868686' // x轴字体颜色
          },
          min: 0,
          max: function(value) {
            return value.max + Math.ceil(value.max * 0.2)
          }
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            name: seriesName, // 增加系列名称
            barWidth: 20,
            itemStyle: {
              color: barColor
            },
            label: {
              show: true,
              position: 'top',
              formatter: `{c}${unit}`,
              color: '#000'
            }
          }
        ]
      }
    },
    // 提取resize监听方法
    initChartResize(chartInstance) {
      const resizeHandler = () => {
        chartInstance.resize()
      }
      if (this.contentRef) {
        // 将ResizeObserver实例存储在chartInstance上
        chartInstance.__resizeObserver = new ResizeObserver(resizeHandler)
        chartInstance.__resizeObserver.observe(this.contentRef)
      }
      window.addEventListener('resize', resizeHandler)
      chartInstance.__resizeHandler = resizeHandler
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('resize', resizeHandler)
      })
    },
    // 获取折线图配置
    getLineChartOption(config = {}, statisticalInfo = []) {
      const {
        seriesName = this.$t('dataAnalysis.synthesis.teachingDataPage.data'),
        lineColors = ['#379EFE', '#FFA311'], // 默认两种颜色
        xAxisName = this.$t('dataAnalysis.synthesis.teachingDataPage.time'),
        yAxisName = this.$t('dataAnalysis.synthesis.teachingDataPage.value'),
        xAxisData = [this.$t('dataAnalysis.synthesis.teachingDataPage.january'), this.$t('dataAnalysis.synthesis.teachingDataPage.february'), this.$t('dataAnalysis.synthesis.teachingDataPage.march')],
        seriesData = [
          [120, 200, 150], // 第一条折线数据
          [80, 180, 130] // 第二条折线数据
        ],
        unit = '',
        smooth = true
      } = config

      // 计算统计值

      return {
        grid: {
          top: 30,
          bottom: 10,
          left: 10,
          right: 30,
          containLabel: true
        },
        tooltip: {
          show: true,
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: (params) => {
            const index = params.dataIndex
            return `
              ${params.name} <br/>
              ${params.seriesName.split(',')[params.seriesIndex]} : ${params.value}${unit} <br/>
              ${this.$t('dataAnalysis.synthesis.teachingDataPage.highestScore')}: ${statisticalInfo.length ? statisticalInfo[index].data[2].value : 80}${this.$t('dataAnalysis.synthesis.teachingDataPage.scoreUnit')} <br/>
              ${this.$t('dataAnalysis.synthesis.teachingDataPage.lowestScore')}: ${statisticalInfo.length ? statisticalInfo[index].data[3].value : 65}${this.$t('dataAnalysis.synthesis.teachingDataPage.scoreUnit')} <br/>
              ${this.$t('dataAnalysis.synthesis.teachingDataPage.medianScore')}: ${statisticalInfo.length ? statisticalInfo[index].data[4].value : 45}${this.$t('dataAnalysis.synthesis.teachingDataPage.scoreUnit')} <br/>
              ${this.$t('dataAnalysis.synthesis.teachingDataPage.averageScore')}: ${statisticalInfo.length ? statisticalInfo[index].data[5].value : 55.5}${this.$t('dataAnalysis.synthesis.teachingDataPage.scoreUnit')}
            `
          }
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          name: xAxisName,
          nameTextStyle: {
            color: '#868686',
            padding: [0, 0, -30, -20],
            fontSize: 11
          },
          axisLine: {
            lineStyle: {
              color: '#E5E5E5'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            // x轴文字的配置
            show: true,
            textStyle: {
              color: '#262626',
              fontSize: 12
            },
            // 核心代码 默认展示4个字超出显示...
            formatter: function(value) {
              // x轴的文字改为竖版显示
              var str = value.split('')
              return str.slice(0, 3).join('') + (str.length > 3 ? '...' : '')
            }
          }
        },
        yAxis: {
          type: 'value',
          name: yAxisName,
          nameTextStyle: {
            color: '#666', // 改为深灰色
            padding: [0, 0, 0, -20]
          },
          axisLine: {
            lineStyle: {
              color: '#E5E5E5'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: '#E5E5E5'
            }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: 'rgba(245,250,254, 0.8)'
            }
          },
          axisLabel: {
            color: '#868686' // x轴字体颜色
          }
        },
        series: seriesData.map((data, index) => ({
          name: seriesName, // 增加系列名称
          data: data,
          type: 'line',
          smooth: smooth,
          itemStyle: {
            color: lineColors[index]
          },
          symbolSize: 8 // 增加小圆点的大小
        }))
      }
    },
    // 获取饼图配置
    getPieChartOption(config = {}) {
      const {
        seriesName = this.$t('dataAnalysis.synthesis.teachingDataPage.data'),
        colors = ['#379EFE', '#FFA311', '#43C391', '#FD8C6C', '#3E9FEC'], // 默认颜色
        seriesData = [
          { value: 335, name: this.$t('dataAnalysis.synthesis.teachingDataPage.directAccess') },
          { value: 310, name: this.$t('dataAnalysis.synthesis.teachingDataPage.emailMarketing') },
          { value: 234, name: this.$t('dataAnalysis.synthesis.teachingDataPage.affiliateAds') }
        ],
        radius = ['20%', '65%'] // 内外半径
      } = config

      return {
        tooltip: {
          show: true,
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} '
        },
        legend: {
          // bottom: '5%',
          // itemWidth: 10,
          // itemHeight: 10,
          // textStyle: {
          //   color: '#333'
          // },
          // left: 'center',
          // // align: 'center', // 添加这一行，使图例内容居中对齐
          // // padding: [10, 50], // 调整上下和左右的内边距
          // itemGap: 10 // 调整图例项之间的间距
          bottom: '8%',
          right: 'center',
          width: '180',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10, // 开启图例分页
          pageButtonItemGap: 5 // 图例分页按钮间隔
        },
        series: [
          {
            name: seriesName,
            type: 'pie',
            radius: radius,
            data: seriesData,
            center: ['50%', '35%'],
            itemStyle: {
              color: function(params) {
                return colors[params.dataIndex % colors.length]
              }
            },
            label: {
              show: false
            }
          }
        ]
      }
    },
    // 获取玫瑰图配置
    getRoseChartOption(config = {}) {
      const {
        seriesName = '',
        colors = ['#379EFE', '#FFA311', '#43C391', '#FD8C6C', '#3E9FEC'],
        seriesData = [
          { value: 335, name: this.$t('dataAnalysis.synthesis.teachingDataPage.directAccess') },
          { value: 310, name: this.$t('dataAnalysis.synthesis.teachingDataPage.emailMarketing') },
          { value: 234, name: this.$t('dataAnalysis.synthesis.teachingDataPage.affiliateAds') }
        ]
      } = config

      // 确保排序正确
      const sortedData = seriesData.slice().sort((a, b) => Number(a.value) - Number(b.value))

      return {
        tooltip: {
          show: true,
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} '
        },
        legend: {
          show: false,
          bottom: '10%',
          left: 'center'
        },
        series: [
          {
            name: seriesName,
            type: 'pie',
            radius: ['20%', '90%'],
            roseType: 'radius',
            data: sortedData,
            center: ['50%', '50%'],
            itemStyle: {
              color: function(params) {
                return colors[params.dataIndex % colors.length]
              }
            },
            label: {
              show: false
            },
            emphasis: {
              label: {
                show: false,
                formatter: '{b}: {c} ({d}%)',
                position: 'center',
                fontSize: 10,
                padding: [0, 0], // 增加内边距
                overflow: 'truncate', // 处理文字溢出
                width: 10, // 设置标签宽度
                ellipsis: '...' // 超出部分显示省略号
              },
              scale: true,
              scaleSize: 1.05
            }
          }
        ]
      }
    },
    getExamineListData() {
      getExamineList({
        pageNumber: 1,
        pageSize: 100
      }).then(res => {
        console.log('res', res)
        if (res.code === 20000) {
          this.testList = res.data.records.map(item => ({
            name: item.testname,
            value: item.id
          }))
        }
      })
      labList({
        page: 1,
        pageSize: 100
      }).then(res => {
        if (res.code === 200) {
          this.experimentList = res.data.list.map(item => ({
            name: item.name,
            value: item.id
          }))
        }
      })
      classList({
        page: 1,
        pageSize: 100
      }).then(res => {
        if (res.code === 200) {
          this.classList = res.data.list.map(item => ({
            name: item.name,
            value: item.id
          }))
        }
      })
    }
  },
  // 在组件销毁时清理所有图表的ResizeObserver
  beforeDestroy() {
    // 获取所有图表实例并清理
    const chartIds = ['chat-1', 'chat-2', 'chat-3', 'chat-4', 'chat-5', 'chat-6-1', 'chat-6-2', 'chat-6-3', 'chat-7']
    chartIds.forEach(id => {
      const chartDom = document.getElementById(id)
      if (chartDom) {
        const chartInstance = echarts.getInstanceByDom(chartDom)
        if (chartInstance) {
          if (chartInstance.__resizeObserver) {
            chartInstance.__resizeObserver.disconnect()
          }
          if (chartInstance.__resizeHandler) {
            window.removeEventListener('resize', chartInstance.__resizeHandler)
          }
        }
      }
    })
  }
}
</script>

<style lang="less" scoped>
.t-content {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  height: 100%;
  > div {
    width: 100%;
    height: calc((100% - 18px) / 3);
    margin-bottom: 9px;
  }
  > div:last-child {
    margin-bottom: 0;
  }
  .t-content-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    > div {
      width: calc((100% - 28px) / 3);
      height: 100%;
      background-color: #fff;
    }
    .rose-chart {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: calc(100% - 48px);
      padding: 0 20px;
      .chart {
        flex: 1;
        height: 100%;
      }
      .legend {
        width: 160px;
        height: 100%;
        flex-wrap: wrap;
        margin-bottom: 20px;
        margin-top: 200px;
        font-size: 11px;
        > div {
          width: 50%;
          float: left;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 10px;
          > div:first-child {
            margin-right: 5px;
            border-radius: 4px;
            width: 10px;
            height: 10px;
          }
        }
      }
    }
  }
  .t-content-center {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    > div {
      width: calc((100% - 14px) / 2);
      height: 100%;
      background-color: #fff;
    }
  }
  .t-content-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    > div {
      width: calc((100% - 14px) / 2);
      height: 100%;
      background-color: #fff;
    }
    .chart-pie {
      height: calc(100% - 46px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      > div {
        width: calc((100% - 20px) / 3);
        height: 100%;
      }
    }
  }
  .t-radius {
    border-radius: 5px;
    .line-chart {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: calc(100% - 46px);
      // padding: 0px 20px;
      .left {
        flex: 1;
        height: 100%;
        background-color: #fff;
        position: relative;
        .class {
          position: absolute;
          left: 35px;
          top: 5px;
          width: 400;
          display: flex;
          align-items: center;
          font-size: 12px;
          > div {
            min-width: 70px;
            height: 10px;
            border-radius: 50%;
            background-color: #fff;
            margin-right: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            > div:first-child {
              margin-right: 5px;
            }
          }
        }
      }
      .right {
        width: 100px;
        border: 1px solid #e2e5e7;
        .lable {
          float: left;
          width: 50%;
          background-color: #edf2f6;
          line-height: 34px;
          text-align: center;
          font-size: 12px;
          color: #6b738c;
        }
        .value {
          float: left;
          width: 50%;
          line-height: 33px;
          text-align: center;
          font-size: 12px;
          color: #6b738c;
          > div {
            border-bottom: 1px solid #eee;
            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
  .header-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 46px;
    color: #6b738c;
    padding: 0px 20px;
    font-size: 14px;
    .name {
      padding-left: 10px;
      position: relative;
      font-weight: 600;
      &::after {
        content: '';
        position: absolute;
        left: -5px;
        top: 5px;
        width: 4px;
        height: 13px;
        background-color: #6b738c;
        border-radius: 2px;
      }
    }
    .info {
      font-size: 13px;
    }
    .rose-chart-info {
      width: 100%;
      padding: 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /deep/ .ant-select-selection__placeholder {
      font-size: 12px;
    }
    /deep/ .ant-calendar-range-picker-input::placeholder {
      font-size: 12px;
    }
    .num {
      font-size: 18px;
      padding-right: 5px;
    }
  }
  .chart {
    width: 100%;
    height: calc(100% - 46px);
  }
  .chart-line {
    // width: calc(100% - 15px);
    height: 100%;
    // margin-right: 15px;
  }
}
</style>
